import { StateKey } from 'common/utils/flipState'
import { fetchReviewProducts, filterWritableReviewProducts } from 'common/services/review'
import { ReviewProduct, MySizeTarget, RegisterReviewState, ReviewUserInputForm } from 'common/types/entities/api/review'

export const initialState: RegisterReviewState = {
  orderNo: null,
  reviewProducts: [],
  selectedProductOrderNos: [],
  currentReviewProduct: null,
  nextReviewProduct: null,
  mySizeTargets: [],
  errorMessage: null,
  result: null,
}

const INIT = 'review/registration/INIT'
const ERROR = 'review/registration/ERROR'
const SET_SELECTED_PRODUCT_ORDER_IDS = 'review/registration/SET_SELECTED_PRODUCT_ORDER_NOS'
const SET_CURRENT_REVIEW_PRODUCT = 'review/registration/SET_CURRENT_REVIEW_PRODUCT'
const SET_RESULT = 'review/registration/SET_RESULT'
const ADD_MYSIZE_TARGET = 'review/registration/ADD_MYSIZE_TARGET'

let currentIndex = 0

export const initRegisterReview = (curState: StateKey, payload, headers) => async dispatch => {
  const { orderNo, productOrderNos } = payload
  try {
    const reviewProducts = (await fetchReviewProducts(orderNo, productOrderNos, headers)) || []
    const filteredReviewProducts = filterWritableReviewProducts(reviewProducts) || []
    const currentReviewProduct = filteredReviewProducts.length === 1 ? filteredReviewProducts[0] : null
    dispatch({
      curState,
      orderNo,
      currentReviewProduct,
      type: INIT,
      reviewProducts: filteredReviewProducts,
    })
  } catch (e) {
    dispatch({
      curState,
      orderNo,
      type: ERROR,
      errorMessage: e,
    })
  }
}

export const setSelectedProductOrderNos = (curState: StateKey, selectedProductOrderNos: string[]) => async (
  dispatch,
  getState,
) => {
  const { reviewProducts } = getState().registerReview[curState]

  dispatch(setCurrentReviewProduct(curState, reviewProducts, selectedProductOrderNos))

  dispatch({
    curState,
    selectedProductOrderNos,
    type: SET_SELECTED_PRODUCT_ORDER_IDS,
  })
}

export const setCurrentReviewProduct = (
  curState: StateKey,
  reviewProducts: ReviewProduct[],
  selectedProductOrderNos: string[],
) => async dispatch => {
  const getReviewProductByProductOrderId = (productOrderNo: string) => {
    return reviewProducts.find((item: ReviewProduct) => item.productOrderNo === productOrderNo)
  }

  const currentReviewProduct: ReviewProduct = getReviewProductByProductOrderId(selectedProductOrderNos[currentIndex])
  currentIndex = currentIndex + 1
  const nextReviewProduct: ReviewProduct = getReviewProductByProductOrderId(selectedProductOrderNos[currentIndex])

  dispatch({
    curState,
    currentReviewProduct,
    nextReviewProduct,
    type: SET_CURRENT_REVIEW_PRODUCT,
  })
}

export const addMySizeTarget = (curState: StateKey, mySizeTarget: MySizeTarget) => (dispatch, getState) => {
  const { mySizeTargets = [] } = getState().registerReview[curState]

  dispatch({
    curState,
    mySizeTargets: [...mySizeTargets, mySizeTarget],
    type: ADD_MYSIZE_TARGET,
  })
}

export const setResultOfRegisterReview = (curState: StateKey, form: ReviewUserInputForm) => dispatch => {
  dispatch({
    curState,
    result: form,
    type: SET_RESULT,
  })
}

const registerReviewReducer = (state = initialState, action) => {
  const {
    type,
    orderNo,
    reviewProducts,
    selectedProductOrderNos,
    currentReviewProduct,
    nextReviewProduct,
    mySizeTargets,
    errorMessage,
    result,
  } = action

  switch (type) {
    case INIT:
      return {
        ...state,
        orderNo,
        reviewProducts,
        currentReviewProduct,
        mySizeTargets: [],
        errorMessage: null,
      }
    case ERROR:
      return {
        ...state,
        orderNo,
        errorMessage,
      }
    case SET_SELECTED_PRODUCT_ORDER_IDS:
      return {
        ...state,
        selectedProductOrderNos,
        errorMessage: null,
      }
    case SET_CURRENT_REVIEW_PRODUCT:
      return {
        ...state,
        currentReviewProduct,
        nextReviewProduct,
        errorMessage: null,
      }
    case ADD_MYSIZE_TARGET:
      return {
        ...state,
        mySizeTargets,
        errorMessage: null,
      }
    case SET_RESULT:
      return {
        ...state,
        result,
      }
    default:
      return state
  }
}

export default registerReviewReducer
